import React, { useState ,useEffect} from "react";
import "./Curriculum.css";
import starfish from "../Image/starfishnew.png";
import dolphin from "../Image/dolphin.png";
import tadpole from "../Image/tadpole.png";
import shark from "../Image/great-white-shark.png";
import narwhal from '../Image/narwhal.png';
import turtle from '../Image/sea-turtle.png';
import { initFacebookPixel } from '../facebookPixel';
const curriculumData = [
  {
    title: "Day 1 to Day 3: Foundation & Water Familiarity",
    points: [
      "Introduction to Water: Walking in the pool with and without support.",
      "Breath Control: Breath-holding and bubble-blowing exercises.",
      "Basic Motor Skills: Flutter kicks from the deck and blowing balls across the water.",
      "Confidence Building: Fun activities like ball races and interactive games.",
      "Progression: Learning to dip the face and eventually the whole head in the water while blowing bubbles.",
      "Coordination: Picking up objects from the pool floor.",
    ],
  },
  {
    title: "Day 3 to Day 5: Floating & Body Control",
    points: [
      "Reinforcing Breath Control: Blowing bubbles at different levels (mouth, face, head underwater).",
      "Building Independence: Floating against the wall and learning to regain position.",
      "Introduction to Floating Aids: Using noodles for support.",
      "Developing Water Balance: Floating with and without support.",
      "Fun Water Challenges: Engaging in activities like Ringa Ringa Roses and Mushroom Float.",
    ],
  },
  {
    title: "Day 5 to Day 7: Gliding & Basic Swimming Movements",
    points: [
      "Refining Floating Skills: Floating independently and regaining position.",
      "First Steps in Swimming: Gliding with and without support.",
      "Kick Strength Development: Practicing leg action from the deck and inside the water.",
      "Building Water Stamina: Increasing endurance through guided floating and movement drills.",
      "Exciting Group Activities: Fun activities like Star Float and Gliding through Hoops.",
    ],
  },
  {
    title: "Day 7 to Day 9: Kicking Techniques & Underwater Control",
    points: [
      "Mastering Gliding: Progressing from assisted to independent gliding.",
      "Leg Strength & Control: Practicing different kicking drills with kickboards and noodles.",
      "Water Coordination: Combining breath control, kicking, and floating techniques.",
      "Freestyle Basics: Introduction to proper head positioning and movement.",
      "Fun Drills: Kicking races and floating competitions to make learning engaging.",
    ],
  },
  {
    title: "Day 9 to Day 11: Developing Swimming Independence",
    points: [
      "Advanced Kicking Techniques: Learning back kicks and freestyle kicks with floating aids.",
      "Freestyle Fundamentals: Gliding, kicking, and breathing techniques.",
      "Building Endurance: Swimming 5 meters with controlled breathing.",
      "Water Balance Mastery: Practicing back floats and dog paddle techniques.",
      "Interactive Learning: Relay races and fun float activities.",
    ],
  },
  {
    title: "Day 11 to Day 13: Stroke Fundamentals",
    points: [
      "Introduction to Backstroke: Practicing back kicks with support.",
      "Freestyle Techniques: Learning arm movement coordination.",
      "Strengthening Strokes: Practicing streamlined kicking with proper breathing.",
      "Endurance Building: Swimming short distances with minimal support.",
      "Engaging Challenges: Star Float and Mushroom Float activities.",
    ],
  },
  {
    title: "Day 13 to Day 15: Mastering Basics & Preparing for Independent Swimming",
    points: [
      "Combining All Skills: Floating, gliding, kicking, and breathing together.",
      "Streamline Freestyle Kick: Practicing with proper positioning.",
      "Swimming with Confidence: Attempting freestyle swimming for 5 meters independently.",
      "Refining Stroke Efficiency: Focused drills to improve body coordination.",
      "Final Fun Challenge: Streamline Kick Race and water confidence exercises.",
    ],
  },
];

const images = [starfish, dolphin, tadpole, shark,narwhal,turtle];

const Curriculum = () => {
  const [showMore, setShowMore] = useState(false);
  useEffect(() => {
    initFacebookPixel(); // Track page view when this page loads
  }, []);
  return (
    <div className="curriculum-container">
      <h2 className="curriculum-heading">Curriculum</h2>
   
      <div className="button-container-active">
  <button className="active-nav-btn">
    15 Sessions
  </button>
</div>

     
      <div className="curriculum-content">
        <div className="curriculum-text-container">
          {curriculumData.slice(0, showMore ? curriculumData.length : 1).map((section, index) => (
            <div key={index} className="curriculum-section">
              <h3 className="level-title">{section.title}</h3>
              <ul className="curriculum-list">
                {section.points.map((point, i) => (
                  <li key={i} className="curriculum-item">
                    <img src={images[i % images.length]} alt="Step Icon" className="curriculum-image-small" />
                    {point}
                  </li>
                ))}
              </ul>
            </div>
          ))}
            <div className="button-container-cirriculum">
          {!showMore && (
                <button className="read-more-btn" onClick={() => setShowMore(true)}>
                  ▼
                </button>
              )}
        
          </div>
        </div>
      </div>
    </div>
  );
};

export default Curriculum;
